import { defineMessages } from 'react-intl';

const messages = defineMessages({
  feedTitle: {
    defaultMessage: 'Designs picked for you',
    description: 'Heading for the feed of work recommendations.'
  }
});

export default messages;
